import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import useAuth from '../hooks/useAuth';
import './layout.css';

export default function Layout() {
  const { logout, user, currentBranch, selectBranch } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    setSidebarOpen(false);
    logout();
    navigate('/login');
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="app-shell">
      <header className="topbar">
        <button type="button" className="hamburger" onClick={() => setSidebarOpen((s) => !s)} aria-label={sidebarOpen ? 'Close menu' : 'Open menu'} aria-expanded={sidebarOpen}><span /><span /><span /></button>
        <div className="topbar-title" style={{ display: 'flex', alignItems: 'center' }}>
          Lotus Admin
          {user?.role === 'center_manager' && currentBranch && (
            <span style={{
              fontSize: '12px',
              background: '#ede9fe',
              color: '#7c3aed',
              padding: '4px 10px',
              borderRadius: '20px',
              marginLeft: '12px',
              fontWeight: 600,
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px'
            }}>
              📍 {currentBranch.name}
            </span>
          )}
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
          {user?.role === 'center_manager' && user.assigned_branches?.length > 1 && (
            <div style={{ marginRight: '16px' }}>
              <select
                value={currentBranch?.branch_id || ''}
                onChange={(e) => {
                  const selected = user.assigned_branches.find(b => b.branch_id === parseInt(e.target.value));
                  if (selected) selectBranch(selected);
                }}
                style={{
                  padding: '6px 12px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  fontSize: '13px',
                  fontWeight: 500,
                  background: '#fff',
                  cursor: 'pointer',
                  outline: 'none',
                  color: '#374151'
                }}
              >
                {user.assigned_branches.map((b) => (
                  <option key={b.branch_id} value={b.branch_id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <button className="logout-button" onClick={handleLogout}>Logout</button>
        </div>
      </header>
      {sidebarOpen && <button type="button" className="sidebar-backdrop" onClick={closeSidebar} aria-label="Close menu" />}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '16px 20px', marginBottom: '20px' }}>
          <img src={process.env.PUBLIC_URL + '/Lotus_logo.jpeg'} alt="Lotus Logo" style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(255,255,255,0.2)' }} />
          <h1 style={{ margin: 0, fontSize: '1.25rem', color: '#fff', fontWeight: 700 }}>Lotus Admin</h1>
        </div>
        <nav onClick={closeSidebar}>
          {user?.role === 'admin' || user?.role === 'center_manager' ? (
            <>
              <NavLink to="/" end>Dashboard</NavLink>
              {user?.role === 'admin' && (
                <>
                  <NavLink to="/branches">Branches</NavLink>
                  <NavLink to="/center-managers">Center Managers</NavLink>
                </>
              )}
              {user?.role === 'center_manager' && (
                <NavLink
                  to="/staff"
                  className={({ isActive }) =>
                    isActive || location.pathname.startsWith('/teachers') ? 'active' : ''
                  }
                >Staff</NavLink>
              )}
              {user?.role === 'admin' && (
                <NavLink
                  to="/teachers"
                  end
                  className={({ isActive }) =>
                    isActive || (location.pathname.startsWith('/teachers/') && !location.search.includes('from='))
                      ? 'active' : ''
                  }
                >Teachers</NavLink>
              )}
              <NavLink
                to="/parents"
                end
                className={({ isActive }) =>
                  isActive ||
                  (location.pathname.startsWith('/parents/') && !location.search.includes('from=')) ||
                  location.search.includes('from=parents')
                    ? 'active' : ''
                }
              >Parents</NavLink>
              <NavLink
                to="/students"
                end
                className={({ isActive }) =>
                  isActive ||
                  (location.pathname.startsWith('/students/') &&
                    !location.search.includes('from=parents') &&
                    !location.search.includes('from=attendance') &&
                    !location.search.includes('from=activities')) ||
                  location.search.includes('from=student')
                    ? 'active' : ''
                }
              >Students</NavLink>
              <NavLink
                to="/student-promotion"
                end
                className={({ isActive }) => (isActive ? 'active' : '')}
              >Student Promotion</NavLink>
              <NavLink to="/chat">Chat Monitoring</NavLink>
              <NavLink
                to="/attendance"
                className={({ isActive }) =>
                  isActive || location.search.includes('from=attendance')
                    ? 'active' : ''
                }
              >Attendance</NavLink>
              <NavLink
                to="/activities"
                end
                className={({ isActive }) =>
                  isActive || location.search.includes('from=activities')
                    ? 'active' : ''
                }
              >Activities</NavLink>
              <NavLink
                to="/announcements"
                end
                className={({ isActive }) =>
                  isActive || location.search.includes('from=announcements')
                    ? 'active' : ''
                }
              >Announcements</NavLink>
              <NavLink to="/notifications">Notifications</NavLink>
              <NavLink to="/pickup">Pickup</NavLink>
              <NavLink
                to="/reports"
                className={({ isActive }) =>
                  isActive && !location.search.includes('from=student')
                    ? 'active' : ''
                }
              >Reports</NavLink>
              <NavLink to="/tracker">Tracker</NavLink>
              <NavLink to="/compliance">Compliance</NavLink>
              <NavLink to="/settings">Settings</NavLink>

              {user?.role === 'center_manager' && (
                <div style={{
                  marginTop: '16px',
                  padding: '16px',
                  background: '#ede9fe',
                  borderRadius: '12px',
                  color: '#7c3aed',
                  fontSize: '13px',
                  fontWeight: 600,
                  textAlign: 'center',
                  border: '1px solid #ddd6fe'
                }}>
                  Managing: {currentBranch?.name || 'No Branch Selected'}
                </div>
              )}
            </>
          ) : (
            <>
              <NavLink
                to="/activities"
                end
                className={({ isActive }) =>
                  isActive || window.location.search.includes('from=activities')
                    ? 'active' : ''
                }
              >Activities</NavLink>
              <NavLink to="/reports">Reports</NavLink>
            </>
          )}
        </nav>
        <div style={{ marginTop: 24 }}>
          <button type="button" className="logout-button" onClick={handleLogout}>Logout</button>
        </div>
      </aside>
      <main className={`main-content ${location.pathname.startsWith('/chat') ? 'chat-view-main' : ''}`}>
        <Outlet />
      </main>
    </div>
  );
}
